import React from 'react';
import EmptyPage from '../EmptyPage';

const QuoteHistoryPage: React.FC = () => {
  return (
    <EmptyPage
      title="견적 내역"
      icon="History"
      description="과거 견적 내역과 현황을 확인합니다."
      parentTitle="견적"
    />
  );
};

export default QuoteHistoryPage;
